import { useEffect } from "react";

const SITE = "https://visitrino.com";

export default function Seo({ title, description, image, type = "website", jsonLd, canonicalPath }) {
  useEffect(() => {
    const full = title ? `${title} | Visit RiNo` : "Visit RiNo — Denver's River North Art District";
    document.title = full;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Visit RiNo");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    // canonical
    const path = canonicalPath || (typeof window !== "undefined" ? window.location.pathname : "");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", SITE + path);

    // structured data (JSON-LD)
    let script = document.head.querySelector('script[data-seo-jsonld="1"]');
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "1");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      const s = document.head.querySelector('script[data-seo-jsonld="1"]');
      if (s) s.remove();
    };
  }, [title, description, image, type, jsonLd, canonicalPath]);

  return null;
}
